import { CrudList } from '../shared/CrudPage';
import { accountService, enumLabel } from '@kss/api';
import type { Account, AccountCreate, AccountFilter } from '@kss/api';
import { StatusBadge } from '@kss/ui';

export default function AllAccounts() {
  return (
    <CrudList<Account, AccountCreate, AccountFilter>
      title="Chart of accounts" newLabel="New account" service={accountService}
      idKey="accountId" labelKey="name" basePath="/panel/accounts"
      columns={[
        { accessor: 'code', title: 'Code', sortable: true, filterable: true, width: 120 },
        { accessor: 'name', title: 'Name', sortable: true, filterable: true },
        { accessor: 'accountType', title: 'Type', sortable: true, filterable: true, render: (r) => enumLabel('AccountType', typeof r.accountType === 'number' ? r.accountType : Number(r.accountType)) },
        // The live Account row DOES carry a `description` column
        // (verified 2026-05-05) — surface it next to the type so
        // bookkeepers can scan the chart at a glance.
        { accessor: 'description', title: 'Description', sortable: true, filterable: true, render: (r) => r.description || '—' },
        {
          accessor: 'openingBalance',
          title: 'Opening (₹)',
          sortable: true,
          textAlign: 'right',
          render: (r) =>
            Number((r as Account & { openingBalance?: number }).openingBalance ?? 0).toLocaleString(
              'en-IN',
            ),
        },
        { accessor: 'isActive', title: 'Status', sortable: true, render: (r) => <StatusBadge status={r.isActive ? 'active' : 'inactive'} /> },
      ]}
    />
  );
}
